import { Pie } from "react-chartjs-2";
import "chart.js/auto";
import "../styles/ResultsGraph.css";

export default function ResultsGraph({ result, loading }) {
  if (loading) {
    return <p className="loading-text">Scanning...</p>;
  }

  if (!result) {
    return <p>No result yet</p>;
  }

  const createPieData = (probability) => ({
    labels: ["Malware", "Benign"],
    datasets: [
      {
        data: [probability, 1 - probability],
        backgroundColor: ["#ff4c4c", "#4caf50"],
      },
    ],
  });

  // Single model
  if (result.model_used) {
    const pieData = createPieData(result.probability);

    return (
      <div className="results-graph animate">
        <h4>File: {result.filename}</h4>
        <h4>{result.model_used.toUpperCase()} Result</h4>

        <Pie data={pieData} />

        <p>
          Prediction: <strong>{result.prediction}</strong>
        </p>
      </div>
    );
  }

  // Compare mode
  if (result.results) {
    const rfData = createPieData(result.results.random_forest.probability);
    const xgbData = createPieData(result.results.xgboost.probability);

    return (
      <div className="results-graph-compare animate">
        <h4>File: {result.filename}</h4>

        <div className="compare-chart">
          <h4>Random Forest</h4>
          <Pie data={rfData} />
          <p>
            Prediction:{" "}
            <strong>{result.results.random_forest.prediction}</strong>
          </p>
        </div>

        <div className="compare-chart">
          <h4>XGBoost</h4>
          <Pie data={xgbData} />
          <p>
            Prediction: <strong>{result.results.xgboost.prediction}</strong>
          </p>
        </div>
      </div>
    );
  }

  return <p>Invalid result format</p>;
}